import React from "react";
import './Offices.css'
import { ImageTitle } from '../../components/ImageTitle'
import Typography from "@mui/material/Typography";
import { Header } from "../../components/Header";
import {OfficeCarousel} from "../../components/OfficeCarousel";

interface OfficesProps {
    imageUrl: string;
    title: string;
    path: string;
}

const Offices: React.FC<OfficesProps> = ({ imageUrl, title, path }) => {

    return (
        <>
            <Header variant={2} />
            <ImageTitle imageUrl={imageUrl} title={title} path={path} />

            <div className="offices-title">
                <Typography
                    sx={{
                        color: '#ff6c00',
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '20px',
                        fontWeight: 500,
                    }}
                >
                    Visítanos
                </Typography>
                <Typography
                    sx={{
                        color: '#3b3b3b',
                        fontFamily: "Inter, sans-serif",
                        fontSize: '44px',
                        fontWeight: 700,
                        lineHeight: '1.2em',
                    }}
                >
                    Conoce nuestras oficinas
                </Typography>
            </div>

            <div>
                <OfficeCarousel />
            </div>
        </>
    )
}

export default Offices;